import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import useProfitMargin from "./useProfitMargin";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const { reset, handleSubmit, setErrors, setData, profitMarginFields } = useProfitMargin();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('categories-shops').then(res => {
      setData({ data: res?.data });
    });

    axios.get('profitMargins/' + id).then(res => {
      reset(res.data.profitMargin);
    });
  }, []);

  const editProfitMargin = data => {
    axios.put('profitMargins/' + data.id, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Profit margin has been updated successfully!', {
            icon: "success",
          });
          navigate("/profit-margins");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit profit margin">
      <form className="form w-100 row" onSubmit={handleSubmit(editProfitMargin)}>
        {profitMarginFields}
        <div className="col-12 mt-10">
          <SubmitButton
            title="Update"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}